import "./Faq01.css";

import React, { useState } from "react";

function Faq01() {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "What types of tyres do you collect?",
      answer:
        "We collect almost all types of pneumatic tyres, including car, van, truck, motorcycle, and agricultural tyres. Please contact us if you have specialist tyres (e.g., solid forklift or aircraft tyres) to discuss a specific solution.",
    },
    {
      question: "How are the tyres recycled?",
      answer:
        "We use a mechanical shredding process to break tyres down into their core components: rubber, steel, and fibre. These materials are then processed into new products like fuel, playground surfaces, or construction materials, ensuring nothing goes to landfill.",
    },

    {
      question: "How do I get a quote?",
      answer:
        "Simply fill out the contact form on our website or call our team at [01332 123456]. Let us know the approximate quantity and type of tyres, along with your location, and we will provide a free, no-obligation quote.",
    },
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <div className="Faq01 section" id="Faq01">
      <div className="container">
        <div className="Faq01-box">
          <div className="Faq01-box-left">
            <p className="eyebrow">FAQs</p>
            <h2>Frequently Asked Questions.</h2>
            <p>And other things, that we think you should know.</p>
          </div>

          <div className="Faq01-box-right">
            {faqs.map((faq, index) => (
              <div key={index} onClick={() => toggleAnswer(index)}>
                <h3>{faq.question}</h3>
                {activeIndex === index && (
                  <p className="answer">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq01;
